export function Send() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path d="m15.379 19.14-3.271-6.54 7.359-7.359zM4.86 8.621l13.9-4.087-7.359 7.358zm-1.501-.6a.5.5 0 0 0-.083.927l7.852 3.925 3.925 7.851a.5.5 0 0 0 .927-.083l5-17a.5.5 0 0 0-.621-.62z" />
    </svg>
  )
}
